module.exports = __webpack_public_path__ + "static/media/qr_hehuoren.76f132b7.jpg";